import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37016bce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ai-generation-product-data"
};
const _hoisted_2 = {
  class: "product-info"
};
const _hoisted_3 = {
  class: "image-and-flag"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "product-title"
};
const _hoisted_6 = {
  class: "copy-and-amazon-link"
};
const _hoisted_7 = {
  class: "form-container",
  ref: "formContainer"
};
const _hoisted_8 = {
  class: "label-and-input"
};
const _hoisted_9 = {
  class: "product-data-label",
  style: {
    "border-radius": "0px 20px 0px 0px"
  }
};
const _hoisted_10 = {
  class: "product-data-input"
};
const _hoisted_11 = {
  class: "product-data-input-box brand"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-text"
}, " Verify the brand name. If incorrect, go to Amazon Seller/Vendor Central to fix before generating content here. ", -1));
const _hoisted_13 = {
  class: "label-and-input"
};
const _hoisted_14 = {
  class: "product-data-label"
};
const _hoisted_15 = {
  class: /*#__PURE__*/_normalizeClass(['product-data-input'])
};
const _hoisted_16 = {
  key: 0,
  style: {
    "color": "#999 !important",
    "font-family": "Figtree !important"
  }
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  class: "label-and-input"
};
const _hoisted_19 = {
  class: "product-data-label"
};
const _hoisted_20 = {
  class: "product-data-input"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-text"
}, " Ensure you enter the marketing product name that you want to reuse in the listing ", -1));
const _hoisted_22 = {
  class: "label-and-input additional"
};
const _hoisted_23 = {
  class: "product-data-label additional"
};
const _hoisted_24 = {
  class: "icon-and-label"
};
const _hoisted_25 = {
  key: 0,
  class: "optional"
};
const _hoisted_26 = {
  class: "product-data-input additional",
  ref: "additionalDataTextareaBox"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "new"
}, "New", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_b_spinner = _resolveComponent("b-spinner");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.product.image,
    alt: "",
    width: "32"
  }, null, 8, _hoisted_4), _createVNode(_component_b_img, {
    src: _ctx.getCountryFlag(_ctx.getCountryCode(_ctx.getCountry($props.product.marketplace_id)), 'flat'),
    width: 16,
    height: 16,
    alt: "flag",
    class: "flag"
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_5, _toDisplayString($props.product.product_name), 1), _createElementVNode("div", _hoisted_6, [!$data.is_copied ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "copy-v2",
    size: 16,
    color: "#999999",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.copyTitle())
  })) : (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    icon: "check",
    size: 16,
    color: "#22863D"
  })), _createVNode(_component_app_icon, {
    icon: "link",
    size: 16,
    color: "#999999",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.listingPageAmazon())
  })])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_app_icon, {
    icon: "little-flag"
  }), _createTextVNode(" Brand name*")]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($data.custom_product.brand), 1), _hoisted_12])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_app_icon, {
    icon: "git-branch"
  }), _createTextVNode(" Input data* ")]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_app_dropdown, {
    arrow_icon_color: "#616161",
    class: "input_data_dropdown"
  }, {
    "button-content": _withCtx(() => [$options.checkInputData ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Select the data that should be used for the listing ")) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_flex_row, {
      styles: {
        JustifyContent: 'flex-start',
        color: $data.input_data_type.color
      },
      gap: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: $data.input_data_type.icon,
        color: $data.input_data_type.color,
        size: "16"
      }, null, 8, ["icon", "color"]), _createTextVNode(" " + _toDisplayString($data.input_data_type.text), 1)]),
      _: 1
    }, 8, ["styles"])]))]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.input_data_options, item => {
      return _openBlock(), _createBlock(_component_b_dropdown_item, {
        onClick: $event => $options.onSelectInputData(item)
      }, {
        default: _withCtx(() => [_createVNode(_component_flex_row, {
          styles: {
            JustifyContent: 'flex-start',
            BorderBottom: '1px solid var(--color-semantic-grey-200, #F4F4F4)',
            color: item.color
          },
          gap: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_app_icon, {
            icon: item.icon,
            color: item.color,
            size: "16"
          }, null, 8, ["icon", "color"]), _createTextVNode(" " + _toDisplayString(item?.text), 1)]),
          _: 2
        }, 1032, ["styles"])]),
        _: 2
      }, 1032, ["onClick"]);
    }), 256))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_app_icon, {
    icon: "tag"
  }), _createTextVNode(" Product name*")]), _createElementVNode("div", _hoisted_20, [_withDirectives(_createElementVNode("input", {
    placeholder: "Enter the marketing product name",
    class: "product-data-input-box",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.custom_product.product_name = $event),
    onInput: _cache[3] || (_cache[3] = (...args) => $options.handleCustomDataChange && $options.handleCustomDataChange(...args))
  }, null, 544), [[_vModelText, $data.custom_product.product_name]]), _hoisted_21])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_app_icon, {
    icon: "file"
  }), _createTextVNode("Additional data" + _toDisplayString($data.input_data_type?.value == 'additional' ? '*' : ""), 1)]), $data.input_data_type?.value !== 'additional' ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Optional")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("textarea", {
    placeholder: "Enter or copy-paste any product information to help build your updated Amazon listing. Unstructured data and all languages are accepted. Maximum 1000 words.",
    class: "product-data-input-box additional",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $options.userInput = $event),
    onClick: _cache[5] || (_cache[5] = $event => $data.user_input_import = false),
    onFocus: _cache[6] || (_cache[6] = (...args) => $options.resizeTextarea && $options.resizeTextarea(...args)),
    onKeyup: _cache[7] || (_cache[7] = (...args) => $options.resizeTextarea && $options.resizeTextarea(...args)),
    ref: "additionalDataTextarea"
  }, null, 544), [[_vModelText, $options.userInput]])], 512)]), !$data.user_input_import ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['import-button']),
    onClick: _cache[8] || (_cache[8] = $event => $data.user_input_import = true)
  }, [_createVNode(_component_app_icon, {
    icon: "link-import"
  }), _createTextVNode(" Import from a specific URL "), _hoisted_27])) : _createCommentVNode("", true), $data.user_input_import && !$data.user_input_import_done ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "cancel-import",
    onClick: _cache[9] || (_cache[9] = $event => $data.user_input_import = false)
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    color: "#93999F",
    size: 16
  }), _createTextVNode(" Cancel ")])) : _createCommentVNode("", true), $data.user_input_import ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 2,
    placeholder: "Paste your link here",
    class: _normalizeClass(['import-input', {
      done: $data.user_input_import_done ?? false
    }]),
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.import_link = $event),
    onClick: _cache[11] || (_cache[11] = $event => $data.user_input_import_done = false)
  }, null, 2)), [[_vModelText, $data.import_link]]) : _createCommentVNode("", true), $data.user_input_import ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: _normalizeClass(['fetch-button', {
      done: $data.user_input_import_done ?? false
    }]),
    onClick: _cache[12] || (_cache[12] = (...args) => $options.onFetchButtonClick && $options.onFetchButtonClick(...args))
  }, [!$data.user_input_import_done && !$data.user_input_import_loading ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "ai",
    color: "#FFFFFF",
    size: 16
  })) : _createCommentVNode("", true), $data.user_input_import_done && !$data.user_input_import_loading ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    icon: "check",
    color: "#FFFFFF",
    size: 16
  })) : _createCommentVNode("", true), !$data.user_input_import_done && $data.user_input_import_loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 2,
    small: ""
  })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(!$data.user_input_import_done && $data.user_input_import_loading ? "Fetching data" : !$data.user_input_import_done && !$data.user_input_import_loading ? "Fetch data" : "Successfully fetched all data"), 1)], 2)) : _createCommentVNode("", true)], 512)]);
}